import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  recordingButton: {
    color: "$media_button_bg",
    borderColor: "$media_button_bg",
    backgroundColor: "$input_background",
  },
  recordingButtonIcon: {
    color: "$invalid",
  },
  recordingButtonText: {
    color: "$media_button_bg",
  },
});
